export default function MenuIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 5.5H4.04297"></path>
            <path d="M19 9.5H4.04297"></path>
            <path d="M19 13.5H4.04297"></path>
            <path d="M19 17.5H4.04297"></path>
        </svg>
    )
}